import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common-services/common.service';
import { downloadFiles } from '../../utils';
import {
  FileType,
  USER_ROLE_KEYS,
  USER_ROLE_KEYS_LABELS,
  UserType,
  ChatMetaData
} from '../../constants/constants';
import { UploadDndComponent } from '../upload-dnd/upload-dnd.component';
interface NewComment {
  textMessage: string;
  createdOn?: number;
  receiver: string;
  chatRefId?: number;
  entityType: string;
  entityId: number | undefined;
}

interface Comment {
  createdOn: any;
  id: number;
  chatRefId: number;
  textMessage: string;
  reatedOn: number;
  read: boolean;
  sender: string;
  receiver: string;
}

@Component({
  selector: 'app-comment-sidenav',
  templateUrl: './comment-sidenav.component.html',
  styleUrls: ['./comment-sidenav.component.scss'],
})
export class CommentSideNavComponent implements OnInit, OnChanges, AfterViewChecked {
  @Input() baseUrl: string = '';
  @Input() chatRefId: number | undefined;
  @Input() entityId: number | undefined;
  @Input() metaData!: ChatMetaData;
  @Input() milestoneName = '';
  @Output() childClick = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  comment: string = '';
  commentsList: Comment[] = [];
  fileList: any[] = [];
  @ViewChild('scrollMe') private commentScrollContainer!: ElementRef;
  uploadedDocumentInfo!: any;
  fileUploadConfig: any;
  resetFileUpload = true;
  showCheckboxes = false;
  nextRole = '';
  isSpecialShare: any;
  @ViewChild(UploadDndComponent) uploadDndComponent!: UploadDndComponent;

  //change
  documentInfo: any;
  fileLocation = '';
  isShareBtnDisable: boolean = true;

  @Input() receivers!: USER_ROLE_KEYS[];
  USER_ROLE_LABELS = USER_ROLE_KEYS_LABELS;
  currReceiver = this.metaData?.receivers[0];
  userRole = this.commonService.userRoleKey;
  USER_ROLE_KEYS = USER_ROLE_KEYS;

  @Output() customerChat = new EventEmitter<null>();

  constructor(
    private toastr: ToastrService,
    private commonService: CommonService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.documentInfo = {
      userType: UserType.Admin,
      documentUseFor: FileType.Chat_File,
      baseUrl: this.baseUrl,
    };
    // this.commentsList = [];
    this.entityId = undefined;
    this.milestoneName = '';
    if (changes['baseUrl']) {
      this.baseUrl = changes['baseUrl'].currentValue;
    }
    if (changes['milestoneName']) {
      this.milestoneName = changes['milestoneName'].currentValue;
    }
    if (changes['chatRefId']) {
      this.chatRefId = changes['chatRefId'].currentValue;
    }
    if (changes['entityId']) {
      this.entityId = changes['entityId'].currentValue;
    }
    if (changes['metaData']) {
      this.metaData = changes['metaData'].currentValue;
    }
    // if (this.chatRefId) {
    //   this.getChatById();
    // }
    if (this.entityId) {
      this.getChatById();
    }

    this.fileLocation = `chat/service/${this.metaData.entityType}/${this.entityId}/${this.metaData.receivers}`;
    this.fileUploadConfig = this.createFileConfigObject();
  }

  ngOnInit(): void {
    this.scrollToBottom();
    this.currReceiver = this.metaData?.receivers[0];
    this.setNextRole();
  }

  toggleCheckboxes() {
    this.showCheckboxes = !this.showCheckboxes;
  }

  submitUploadedFiles() {
    this.isShareBtnDisable = true;

    const url = `${this.baseUrl}chat-Library/common-chat/new-chat?service=${this.metaData.service}`;

    let files;
    if (
      this.userRole == USER_ROLE_KEYS.Supplier ||
      this.userRole == USER_ROLE_KEYS.Operations
    ) {
      files = this.uploadedDocumentInfo?.attachment.map((item: any) => {
        return {
          fileId: item.id,
          fileName: item.fileName,
          fileExtension: item.type,
          fileSize: item.size,
          location: item.location,
        };
      });
    }

    if (
      this.userRole !== USER_ROLE_KEYS.Supplier &&
      this.userRole !== USER_ROLE_KEYS.Operations
    ) {
      files = this.fileList
        .filter((file: any) => file.isChecked)
        .map((file: any) => ({
          fileId: file.fileObj.fileId,
          fileName: file.fileObj.fileName,
          fileExtension: file.fileObj.fileExtension,
          fileSize: file.fileObj.fileSize,
          location: file.fileObj.location,
        }));

      if (!files.length) {
        this.toastr.error('Please select at least one file.');
        this.isShareBtnDisable = false;
        return;
      }
    }

    const payload = {
      receiver: this.nextRole ?? this.metaData.receivers[0],
      entityType: this.metaData.entityType,
      entityId: this.entityId,
      saveFiles: files,
    };

    this.commonService.postDatawithoutHeaders(url, payload).subscribe({
      next: (data: any) => {
        this.chatRefId = data.response.chatRefId;
        this.comment = '';
        this.getChatById();
        this.uploadDndComponent?.resetSelectedFileState();
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error('Error while adding new comment');
        this.isShareBtnDisable = false;
        console.log(error);
      },
    });
  }

  isAnyFileChecked(): boolean {
    return this.fileList.some((file) => file.isChecked);
  }

  // onCheckboxChange(file: any) {
  //   file.isChecked = !file.isChecked;
  //   console.log(file.fileName, file.isChecked); // or perform any other action
  // }

  reset() {
    this.uploadDndComponent.resetSelectedFileState();
    this.isShareBtnDisable = true;
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    if (this.commentScrollContainer?.nativeElement) {
      this.commentScrollContainer.nativeElement.scrollTop =
        this.commentScrollContainer.nativeElement.scrollHeight;
    }
  }

  handleFileUpload(fileUploadEvent: any): void {
    this.uploadedDocumentInfo = fileUploadEvent;

    this.uploadedDocumentInfo.attachment.forEach((item: any) => {
      item.isChecked = false; // Set default value
    });

    if (fileUploadEvent.attachment.length === 0) {
      this.isShareBtnDisable = true;
      return;
    }

    this.isShareBtnDisable = false;
  }

  downloadFile(name: string, id: number) {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, name);
  }

  postNewChat(newComment: NewComment) {
    let updateChatId = false;
    if (!newComment.chatRefId) {
      updateChatId = true;
    }
    this.commonService
      .postDatawithoutHeaders(
        `${this.baseUrl}chat-Library/common-chat/new-chat?service=${this.metaData.service}`,
        newComment,
      )
      .subscribe({
        next: (data: any) => {
          this.chatRefId = data.response.chatRefId;
          this.comment = '';
          this.getChatById();
          if (updateChatId) {
            this.updateData.emit(data.response.chatRefId);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('error while adding new comment');
          console.log(error);
        },
      });
  }

  getChatById() {
    if (
      this.commonService.userRoleKey === USER_ROLE_KEYS.Operations &&
      this.currReceiver === USER_ROLE_KEYS.Business_Development
    ) {
      this.customerChat.emit();
    }

    const rec =
      this.metaData.receivers.length > 1 ? this.currReceiver : this.metaData.receivers[0];

    const payload = {
      receiver: rec,
      entityType: this.metaData.entityType,
      entityId: this.entityId,
    };
    this.commonService
      .postDatawithoutHeaders(
        `${this.baseUrl}chat-Library/common-chat/get-all-chat?service=${this.metaData.service}`,
        payload,
      )
      .subscribe({
        next: (data: any) => {
          //reset state
          this.fileList = [];
          this.commentsList = [];

          //segregating comments and files
          data.response?.forEach((obj: any) => {
            if (obj.textMessage != null) {
              this.commentsList.push(obj);
            } else if (obj.fileObj != null) {
              this.fileList.push({ ...obj, isChecked: false });
            }
          });

          if (!this.metaData.hasNewComment) {
            this.updateChatById();
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('Error while getting comments');
          console.log(error);
        },
      });
  }

  updateChatById() {
    const commentIds: any = [];
    this.commentsList.forEach((comment: any) => {
      commentIds.push(comment.id);
    });
    const payload = {
      receiver: this.metaData.receivers,
      idList: commentIds,
    };

    this.commonService
      .update(
        `${this.baseUrl}chat-Library/common-chat/update-chat?service=${this.metaData.service}`,
        '',
        payload,
      )
      .subscribe({
        next: (data: any) => {
          console.log('comment read status updated', data.response);
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('error while getting comments');
          console.log(error);
        },
      });
  }

  close(): void {
    this.childClick.emit(true);
    this.reset();
  }

  updateDataFunc(): void {
    const payload: NewComment = {
      textMessage: this.comment,
      receiver: this.currReceiver ?? this.metaData.receivers[0],
      //chatRefId: this.chatRefId,
      entityType: this.metaData.entityType,
      entityId: this.entityId,
    };
    this.postNewChat(payload);
  }

  trackComment(index: number, comment: any) {
    return comment ? comment.id : undefined;
  }

  private createFileConfigObject() {
    //change
    return {
      uploadLabel: 'Upload File',
      buttonName: 'Choose File',
      dragDropText: 'Drag & Drop File or',
      maxFileText: '(Max file size: 100MB)',
      isMultiple: true,
      fileSizeLimit: 10485760, // 10 mb in bytes
      fileLocation: this.fileLocation,
      fileFormats: '.pdf',
    };
  }

  setNextRole() {
    const rolesSequence = [
      USER_ROLE_KEYS.Supplier,
      USER_ROLE_KEYS.Procurement,
      USER_ROLE_KEYS.Operations,
      USER_ROLE_KEYS.Business_Development,
      USER_ROLE_KEYS.Customer,
    ];

    const indexOfCurrentRole = rolesSequence.indexOf(this.commonService.userRoleKey);
    this.nextRole = rolesSequence[indexOfCurrentRole + 1];
  }
}
